!(function (o) {
  var n = {
    trigger: "onload",
    animation: "fade",
    delay: 100,
    showOnce:!1,
    autoClose: !1,
    scrollableModal: !1,
  };
  o.fn.websenseprosubscribe = function (s) {
    var e = o.extend({}, n, s),
      i = o(this),
      a = !1,
      l = !1;
    switch (
      (i.addClass("sb"),
      (o.fn.openWindow = function () {
       
        o(this).is(":hidden") &&
          !1 == a &&
          !1 == l &&
          ((l = !0),
          setTimeout(function () {
            !0 == e.scrollableModal
              ? o(".sb-overlay").length < 1 &&
                (o("body").append(
                  "<div class='sb-overlay'><div class='sb-close-backdrop'></div><div class='sb sb-withoverlay'>" +
                    o(".sb").html() +
                    "</div></div>"
                ),
                o(".sb-close-backdrop, .sb-close-btn").one(
                  "click",
                  function () {
                    return o(".sb.sb-withoverlay").closeWindow(), !1;
                  }
                ),
                o(".sb.sb-withoverlay")
                  .removeClass(
                    "sb-animation-" + e.animation.replace("In", "Out")
                  )
                  .addClass("sb-animation-" + e.animation),
                setTimeout(function () {
                  o(".sb.sb-withoverlay").show(),
                    o("body").addClass("sb-open sb-open-with-overlay");
                }, 300))
              : o(".sb-overlay").length < 1 &&
                (o("body").append(
                  "<div class='sb-overlay'><div class='sb-close-backdrop'></div></div>"
                ),
                o(".sb")
                  .removeClass(
                    "sb-animation-" + e.animation.replace("In", "Out")
                  )
                  .addClass("sb-animation-" + e.animation),
                o(".sb-close-backdrop, .sb-close-btn").one(
                  "click",
                  function () {
                    return o(".sb").closeWindow(), !1;
                  }
                ),
                setTimeout(function () {
                  o(".sb").show(), o("body").addClass("sb-open");
                }, 300)),
              !0 == e.showOnce && (a = !0),
              (l = !1);
          }, e.delay));
      }),
      (o.fn.closeWindow = function () {
        o(this).is(":visible") &&
          !1 == l &&
          ((l = !0),
          !0 == e.scrollableModal
            ? (o(".sb.sb-withoverlay")
                .removeClass("sb-animation-" + e.animation)
                .addClass("sb-animation-" + e.animation.replace("In", "Out")),
              setTimeout(function () {
                o(".sb.sb-withoverlay").hide(),
                  o("body").removeClass("sb-open sb-open-with-overlay"),
                  setTimeout(function () {
                    o(".sb-overlay").remove();
                  }, 300);
              }, 300))
            : (o(".sb")
                .removeClass("sb-animation-" + e.animation)
                .addClass("sb-animation-" + e.animation.replace("In", "Out")),
              setTimeout(function () {
                o(".sb").hide(),
                  o("body").removeClass("sb-open"),
                  setTimeout(function () {
                    o(".sb-overlay").remove();
                  }, 300);
              }, 300)),
          (l = !1));
      }),
      (o.fn.scrollDetection = function (n, s) {
        var e,
          i = new Date().getTime();
        o(window).scroll(function () {
          var n = new Date().getTime();
          n - i > 400 && (o(this).trigger("scrollStart"), (i = n)),
            clearTimeout(e),
            (e = setTimeout(function () {
              o(window).trigger("scrollEnd");
            }, 300));
        }),
          "scrollStart" == n &&
            o(window).bind("scrollStart", function () {
              o(window).unbind("scrollEnd"), s();
            }),
          "scrollEnd" == n &&
            o(window).bind("scrollEnd", function () {
              o(window).unbind("scrollStart"), s();
            });
      }),
      e.trigger)
    ) {
      case "atendpage":
        o(window).scroll(function () {
          var n = o(window).scrollTop();
          n >= o(document).height() - o(window).height()
            ? i.openWindow()
            : n + 300 < o(document).height() - o(window).height() &&
              !0 == e.autoClose &&
              i.closeWindow();
        });
        break;
      case "onload":
        o(window).on("load", function () {

          i.openWindow(),
            !0 == e.autoClose &&
              i.scrollDetection("scrollStart", function () {
                i.closeWindow();
              });
        });
        break;
      case "onidle":
        o(window).on("load", function () {
          i.scrollDetection("scrollEnd", function () {
            i.openWindow();
          }),
            !0 == e.autoClose &&
              i.scrollDetection("scrollStart", function () {
                i.closeWindow();
              });
        });
    }
  };
})(window.jQuery);
$(document).ready(function () {
  "true" !== localStorage.popupShown &&
    ($(".subscribe-me").websenseprosubscribe(),
    (localStorage.popupShown =""));
});





// var  magnifying_area =document.getElementById('magnifying_area');
// var  magnifying_img =document.getElementById('magnifying_img');


// magnifying_area.addEventListener(('mousemove',function(event) {
//   clientX = event.clientX - magnifying_area.offsetLeft
//     clientY = event.clientX - magnifying_area.offsetTop
//   mWidth=magnifying_area.offsetWidth
//   mHeight=magnifying_area.offsetHeight
//   clientX =  clientX / mwidth * 100
//   clientY=  clientY/ mHeight * 100
  
//    magnifying_img.styles.transform =' translate(-50%,-50%) scale(2)' 
// }
// magnifying_area.addEventListener(('mouseleave',function() {
//    magnifying_img.styles.transform =' translate(-50%,-50%) scale(1)' 
// }




//header hide


// var prevScrollpos = window.pageYOffset;
// window.onscroll = function() {
// var currentScrollPos = window.pageYOffset;
//   if (prevScrollpos > currentScrollPos) {
//     document.getElementById("bottom-nav").style.top = "0";
//   } else {
//     document.getElementById("bottom-nav").style.top = "0";
//   }
//   prevScrollpos = currentScrollPos;
// }


const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))




 function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });


                                  